/* src/app/modules/ct-status/components/cts-gantry-functional-unit-step-labels/cts-gantry-functional-unit-step-labels.component.scss */
:host {
  display: flex;
  flex-flow: row nowrap;
  gap: 0.25rem;
  align-items: center;
  height: 2.25rem;
}
.label {
  text-align: center;
  min-width: 3.5rem;
  width: 100%;
  overflow: hidden;
  text-overflow: clip;
}
/*# sourceMappingURL=cts-gantry-functional-unit-step-labels.component.css.map */
